<template>
	<div class="scrollable only-y">
		<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-message widget-icon accent-text fs-30"></i> {{ $t('menu.template') }}</h2>
			</div>
		</div>
		<el-card>
			<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
			  <el-tab-pane label="Whatsapp Connect" name="waconnect">
			  	<div>
					<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
						<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
							Total Template : <br>
							<span style="font-size:32px;">{{ (total) }}</span>
						</el-card>
					</el-col>
					<el-col>
						<el-button class="mb-10" type="primary" @click="dialogFormVisible = true">+ Add Template Message</el-button>
						<el-input
							class="search-customer mb-10 fl-r" style="width:auto;"
							prefix-icon="el-icon-search"
							placeholder="Search template name"
							clearable
							@clear="getAllHSM"
							@keypress.native="doSearchTemplate"
							@keyup.native="doSearchTemplate"
							v-model="searchTemplate">
						</el-input>
					</el-col>
				</div>
				<div>
					<br/>
					&nbsp;
					<el-pagination
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginateHSM"
						:current-page="currentPage"
						:total="parseInt(total)"/>
					<br/>
					<el-table :data="hsm" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="createdAt" label="Created At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ formatDate(props.row.date_created, "DD/MM/YY HH:mm:ss") }}</p>
							</template>
						</el-table-column>

	                    <el-table-column prop="name" label="Template Name" width="320">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.name }}</p>
							</template>
						</el-table-column>

	                    <el-table-column prop="language" label="Language" width="90">
							<template slot-scope="props">
	                            <p style="font-weight:bold;" v-if="props.row.language">{{ Array.isArray(props.row.language) ? props.row.language[0].toUpperCase() : props.row.language.toUpperCase() }}</p>
								<el-tag type="primary" v-else>-</el-tag>
							</template>
						</el-table-column>

						<el-table-column label="Text Message Template" width="600">
							<template slot-scope="props">
	                            <el-tooltip>
	                                <div style="width: 250px;" class="tooltip" slot="content">{{props.row.message}}</div>
	                                <p style="font-weight:bold;">{{ props.row.message.substring(0, 75) }}...</p>
	                            </el-tooltip>
							</template>
						</el-table-column>

						<el-table-column label="#" width="70">
							<template slot-scope="props">
	                            <el-button size="mini" @click="clickUpdateTemplate(props.row)"><i class="mdi mdi-edit" /></el-button>
							</template>
						</el-table-column>
					</el-table>
					<br/>
					&nbsp;
					<el-pagination
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginateHSM"
						:current-page="currentPage"
						:total="parseInt(total)"/>
					<br/>
				</div>
			  </el-tab-pane>
			  <el-tab-pane label="Business Manager" name="fbbm">
			  	<div>
					<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
						<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
							Total Template : <br>
							<span style="font-size:32px;">{{ (reqTotal) }}</span>
						</el-card>
					</el-col>
				</div>

				<template>
					&nbsp;
					<el-pagination
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginateHSMRequest"
						:current-page="currentPageRequest"
						:total="parseInt(reqTotal)"/>
					<br/>
					<el-table :data="reqTemplate" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="createdAt" label="Created At" width="200">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ formatDate(props.row.createdAt, "DD/MM/YY HH:mm:ss") }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="companyName" label="Company Name" width="150">
							<template slot-scope="props">
								<el-tooltip v-if="props.row.companyName!=null">
									<div style="width: 250px;" class="tooltip" slot="content">{{props.row.companyName}}</div>
									<p style="font-weight:bold;">{{ props.row.companyName }}</p>
								</el-tooltip>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="Name" width="200">
							<template slot-scope="props">
								<el-tooltip>
	                                <div style="width: 250px;" class="tooltip" slot="content">{{props.row.name}}</div>
	                                <p style="font-weight:bold;">{{ props.row.name }}</p>
	                            </el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="language" label="Language" width="100"/>
						<el-table-column prop="text" label="Text" width="400">
							<template slot-scope="props">
								<el-tooltip>
	                                <div style="width: 250px;" class="tooltip" slot="content">{{ getBodyText(props.row.components) }}</div>
	                                <p style="font-weight:bold;">{{ getBodyText(props.row.components).substring(0, 50) }}...</p>
	                            </el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="Status" width="180">
							<template slot-scope="props">
								<el-tag type="danger" v-if="props.row.status=='REJECTED'">{{ props.row.status }}</el-tag>
								<el-tag type="warning" v-else-if="props.row.status=='PENDING'">{{ props.row.status }}</el-tag>
								<el-tag type="success" v-else>{{ props.row.status }}</el-tag>
							</template>
						</el-table-column>
	                    <el-table-column
		                    fixed="right"
		                    label="#"
		                    width="300">
	                        <template slot-scope="scope">
	                        	<span v-if="scope.row.status!='APPROVED'" type="danger" size="small" @click="doShowDialogAddNamespace(scope.row._id)">-</span>
	                            <el-button v-else type="default" size="small" @click="doShowDialogAddNamespace(scope.row._id)">Set namespace</el-button>
								<el-button size="small" :loading="loadingApproved" type="success" v-if="scope.row.status=='PENDING'" @click="approved(scope.row)">Approve</el-button>
								<el-button size="small" :loading="loadingApproved" type="danger" v-if="scope.row.status=='PENDING'" @click="rejected(scope.row)">Reject</el-button>
	                        </template>
	                    </el-table-column>
					</el-table>
					&nbsp;
					<el-pagination
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginateHSMRequest"
						:current-page="currentPageRequest"
						:total="parseInt(reqTotal)"/>
					<br/>
				</template>
			  </el-tab-pane>
			</el-tabs>
		</el-card>

		<el-dialog :title="'Insert namespace for : ' + namespaceCredentials.name + ' (' + namespaceCredentials.language + ')'" :visible.sync="dialogAddNamespace">
            <el-form ref="form" label-width="150px">
            	<el-form-item label="Template Namespace">
                    <el-input v-model="namespaceCredentials.namespace" placeholder="Insert template namespace"></el-input>
                </el-form-item>

                <el-form-item label="Template Name">
                    <el-input v-model="namespaceCredentials.name" disabled></el-input>
                </el-form-item>
				<el-form-item label="Template Header" v-if="namespaceCredentials.header">
					<el-input autosize="{ minRows: 2, maxRows: 10}" type="textarea" v-if="namespaceCredentials.header.format.toLowerCase() == 'text'" v-model="namespaceCredentials.header.text" disabled></el-input>
					<el-input v-else disabled v-model="namespaceCredentials.header.format"/>
				</el-form-item>
                <el-form-item label="Template Body">
                    <el-input autosize="{ minRows: 2, maxRows: 10}" type="textarea" v-model="namespaceCredentials.message" disabled></el-input>
                </el-form-item>
				<el-form-item label="Template Footer" v-if="namespaceCredentials.footer">
					<el-input disabled v-model="namespaceCredentials.footer"/>
				</el-form-item>

				<el-form-item label="Template Language">
                    <el-input type="text" v-model="namespaceCredentials.language" disabled></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="sendTemplateToWAConnect" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogAddNamespace=false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

		<el-dialog title="Add Message Template" :visible.sync="dialogFormVisible">
            <el-form ref="form" label-width="150px">
                <el-form-item label="Template Name">
                    <el-input v-model="hsmParam.name" placeholder="Insert template name"></el-input>
                </el-form-item>

				<el-form-item label="Template Namespace">
                    <el-input v-model="hsmParam.namespace" placeholder="Insert template namespace"></el-input>
                </el-form-item>

				<el-form-item label="Template Message">
                    <el-input type="textarea" v-model="hsmParam.message" autosize="{ minRows: 2, maxRows: 10}" placeholder="Insert template message"></el-input>
                </el-form-item>

				<el-form-item label="Template Language">
                    <template>
                        <el-select v-model="hsmParam.language" placeholder="Select Template Languange">
                            <el-option
                            v-for="item in optionLanguage"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="addHsmTemplate" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogFormVisible=false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

		<el-dialog :title="'Edit Template #' + editTemplate.object.name" :visible.sync="editTemplate.dialog">
            <el-form ref="form" label-width="150px">
            	<el-form-item label="Template Namespace">
                    <el-input v-model="editTemplate.object.namespace" placeholder="Insert template namespace"></el-input>
                </el-form-item>

                <el-form-item label="Template Name">
                    <el-input v-model="editTemplate.object.name"></el-input>
                </el-form-item>
				<el-form-item label="Template Header" v-if="editTemplate.object.header">
					<el-input :autosize="true" type="textarea" v-if="editTemplate.object.header.format.toLowerCase() == 'text'" v-model="editTemplate.object.header.text"></el-input>
					<el-input v-else v-model="editTemplate.object.header.format"/>
				</el-form-item>
                <el-form-item label="Template Body">
                    <el-input :autosize="true" type="textarea" v-model="editTemplate.object.message"></el-input>
                </el-form-item>
				<el-form-item label="Template Footer" v-if="editTemplate.object.footer">
					<el-input v-model="editTemplate.object.footer"/>
				</el-form-item>

				<el-form-item label="Template Language">
                    <el-input type="text" v-model="editTemplate.object.language"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="updateHsmTemplate" :loading="editTemplate.loadingBtn">Save</el-button>
                    <el-button @click="editTemplate.dialog=false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')

export default {
	name: 'HSM',
	data () {
		return {
			editTemplate: {
				dialog: false,
				object: {},
				loadingBtn: false
			},
			hsm:[],
			reqTemplate: [],
			dialogAddNamespace: false,
			selectedTemplateToNamespace: '',
			selectedTemplate: {},
			loadingTemplate: true,
			currentPage: 1,
			currentPageRequest: 1,
			total:'',
			reqTotal: '',
			dialogFormVisible:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			timeout: null,
			hsmParam:{
				name:'',
				namespace:'',
				message:'',
				language:''
			},
			namespaceCredentials: {
				namespace: '',
				name: '',
				message: '',
				language: '',
				templateId: ''
			},
			optionLanguage: [{
				value: 'ID',
				label: 'ID'
			}, {
				value: 'EN',
				label: 'EN'
			}, {
				value: 'EN_US',
				label: 'EN_US'
			}],
			searchTemplate:'',
			activeTab: "waconnect",
			loadingApproved: false
		}
	},
	methods: {
		approved(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to approved this template?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + 'bussiness/approved',
                    method: 'post',
                    data: {
                        status: row.status,
                        templateName: row.name
                    }
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						// this.getRequestTemplate()
						this.paginateHSMRequest(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		rejected(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to reject this template?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + 'bussiness/rejected',
                    method: 'post',
                    data: {
                        status: row.status,
                        templateName: row.name
                    }
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						// this.getRequestTemplate()
						this.paginateHSMRequest(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		clickUpdateTemplate(object){
			this.editTemplate.object = _.clone(object)
			this.editTemplate.dialog = true
		},
		getBodyText(components){
			let c = components.find(v => v.type.toLowerCase() == "body")
			if(c){
				return c.text
			} else {
				return ""
			}
		},
		tabClick(tab){
			if(tab.name == "waconnect"){
				this.getAllHSM()
			} else if(tab.name == "fbbm"){
				this.getRequestTemplate()
			}
		},
		doShowDialogAddNamespace(key){
            this.dialogAddNamespace = true
			var selectedTemplate = this.reqTemplate.find(v=>v._id==key)
			let header = selectedTemplate.components.find(v => v.type.toLowerCase() == "header"), body = selectedTemplate.components.find(v => v.type.toLowerCase() == "body"), footer = selectedTemplate.components.find(v => v.type.toLowerCase() == "footer")
            this.namespaceCredentials = {
				namespace: '',
				name: selectedTemplate.name,
				header: header,
				message: body ? body.text : null,
				footer: footer ? footer.text : null,
				language: selectedTemplate.language,
				templateId: selectedTemplate.templateId
			}
        },
		readMore(text){
			if(text){
				if(text.length > 100) return text.substring(0, 100) + "..."
				else return text
			} else{
				return text
			}
		},
		doSearchTemplate(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				let keyword = ev.target.value
				if(keyword != ""){
					this.searchTemplate = keyword
					this.getAllHSM()
				} else {
					this.searchTemplate = undefined
					this.getAllHSM()
				}
			}, 1000)
	    },
		deleteRow(index, rows) {
            rows.splice(index, 1);
        },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async addHsmTemplate(){
			if(_.isEmpty(this.hsmParam.name) || _.isEmpty(this.hsmParam.namespace) || _.isEmpty(this.hsmParam.message) || _.isEmpty(this.hsmParam.language)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'hsm/add',
				method:'POST',
				data:{
					name:this.hsmParam.name,
					namespace:this.hsmParam.namespace,
					message:this.hsmParam.message,
					language:this.hsmParam.language
				}
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogFormVisible = false
					this.getAllHSM()
				}
				this.loadingBtn = false
			}).catch(error => {
				return error
			})
		},
		async updateHsmTemplate(){
			let obj = this.editTemplate.object
			if(_.isEmpty(obj.name) || _.isEmpty(obj.namespace) || _.isEmpty(obj.message) || _.isEmpty(obj.language)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
			this.editTemplate.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi + 'hsm/' + obj._id,
				method:'patch',
				data:{
					name: obj.name,
					namespace: obj.namespace,
					message: obj.message,
					language: obj.language
				}
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('warning'), "Failed update this template", "warning")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.editTemplate.dialog = false
					this.getAllHSM()
				}
			}).catch(error => {
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
			this.editTemplate.loadingBtn = false
		},
		async sendTemplateToWAConnect(){
			if(_.isEmpty(this.namespaceCredentials.namespace)){
                this.$message.error({
                    showClose: false,
                    message: 'Please insert namespace'
                });
                return
            }
			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add',
				method:'POST',
				data:{
					templateId: this.namespaceCredentials.templateId,
					name:this.namespaceCredentials.name,
					namespace:this.namespaceCredentials.namespace,
					message:this.namespaceCredentials.message,
					header:this.namespaceCredentials.header,
					footer:this.namespaceCredentials.footer,
					language:this.namespaceCredentials.language
				}
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
					this.dialogAddNamespace = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.dialogAddNamespace = false
					this.getRequestTemplate()
				}
				this.loadingBtn = false
			}).catch(error => {
				return error
			})
		},
		async getAllHSM(page = 1){
			this.loadingTemplate = true
			var self = this
			await api({
				url:config.baseApi + 'hsm',
				params: {
					page: page,
					search: this.searchTemplate,
					limit: 10
				},
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.hsm = response.data.data.list
					// this.hsm = _.remove(response.data.data, (v) => { return _.isEmpty(v.message) == false })
					this.total = response.data.data.total
					console.log('hsm list',this.hsm)
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async paginateHSMRequest(page) {
			this.currentPageRequest = page
			await this.getRequestTemplate(page)
		},
		async paginateHSM(page){
			this.currentPage = page
			await this.getAllHSM(this.currentPage)
		},
		async getRequestTemplate(page = 1){
			await api({
				url: config.baseApi+'bussiness/get-template',
				method: 'GET',
				params: {
					page
				}
			}).then(({ data }) => {
				this.reqTemplate = data.data.data
                this.reqTotal = data.data.total
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		clear(){
			this.hsmParam.name = ""
			this.hsmParam.namespace = ""
			this.hsmParam.message = ""
			this.hsmParam.language = ""
			this.namespaceCredentials.namespace = ''
		}
	},
	async mounted(){
		await this.getAllHSM()
		this.getRequestTemplate()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
